export default function richImage(richText) {
  if (!richText) {
    return
  }
  return richText.replace(/\<img/gi,'<img style="max-width:100%;height:auto;display:block;" ');
}